import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal} from "components";
import {MainInfo} from "fragments";
import {AddPatient} from "./fragments";
import {patientsHead, patientsBody, emptyState} from "./constants";
import {PatientSingle} from "./patientSingle";
import {httpRequestsOnSuccessActions, patientsActions} from "store";
import {FindSuccess, limit, useModal, useDetailModal} from "utils";

const ACTION_TYPE = "GET_PATIENTS";
const ACTION_DELETE = "DELETE_PATIENT";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_PATIENTS";


export const Patients = () => {
    const patientsList = useSelector((state) => state.patients?.patientsList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const {openDetail} = useDetailModal();
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);
    const info = location?.state;

    const getPatients = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;
        dispatch(patientsActions.getPatients(params, noLoad));
    }


    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS))
            getPatients(true)
        }
    }, [successChangeStatus]);

    useEffect(() => {
        getPatients()
    }, [info]);

    const addPatient = (item) => {
        openModal(<AddPatient info={item} afterSuccess={() => getPatients(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 756
        });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(patientsActions.deletePatient(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.firstName} ?`}
                afterSuccess={() => {
                    getPatients(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleClickRow = (item) => {
        openDetail(<PatientSingle item={item} afterSuccess={() => getPatients(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1500,
            styles:{  height: '85vh' }
        });
    };

    return (
        <div className="patients-page-wrapper">
            <MainInfo
                buttonText="Add Patient"
                headerTable={patientsHead()}
                bodyTable={patientsBody({
                    handleDelete,
                    handleEit: (item) => addPatient(item),
                })}
                clickToAddButton={() => addPatient()}
                listTable={patientsList?.patients}
                listCountTable={patientsList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addPatient)}
            />
        </div>
    );
};
